/* tslint:disable */

/**
 */
export class Translation {
    CODE_LANGUE?: number;
    ID_TRANSLATION?: number;
    TRANS_TYPE?: number;
    LABEL?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/translation.ts